export const EXCMCUSTOMFIELD_DELETE_RESET = 'EXCMCUSTOMFIELD_DELETE_RESET'
export const EXCMCUSTOMFIELD_DELETE_SET_ERROR = 'EXCMCUSTOMFIELD_DELETE_SET_ERROR'
export const EXCMCUSTOMFIELD_DELETE_SET_DELETED = 'EXCMCUSTOMFIELD_DELETE_SET_DELETED'
export const EXCMCUSTOMFIELD_DELETE_TOGGLE_LOADING = 'EXCMCUSTOMFIELD_DELETE_TOGGLE_LOADING'
